module.exports = __webpack_public_path__ + "img/5f_r_musashi.8ac288fd.jpg";